import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BatchService} from '../batch.service';
import {ToastrService} from 'ngx-toastr';
import * as moment from 'moment';
import * as _ from 'lodash';
import {environment} from '../../../../../../environments/environment';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ModalCancelStampComponent} from '../../popup/modalCancelStamp.component';
import {Subscription} from 'rxjs/Subscription';
import {ImageService} from '../../../../imageService';
import {Subject} from 'rxjs/Subject';
import {HistoryActiveService} from '../historyActive/services/historyActive.service';
import {EvsAddressService} from 'app/common/services/EvsAddress.service';
import {UploadService} from 'app/common/services/Upload.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {IOption} from 'ng-select';
import {EvsErr} from '../../../evs/evsErr';
import {EvsStampService} from '../../../../../common/services/EvsStamp.service';
import {EvsProductService} from '../../../../../common/services/EvsProduct.service';
import {ExportService} from '../../../../../common/services/Export.service';
import { TranslateService } from '@ngx-translate/core';

declare function enterScreenView(screenName: any, contentType: any, referrer: any);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);

declare var $: any;

@Component({
  selector: 'list-batch-child',
  templateUrl: './modalListBatchChild.template.html',
  styleUrls: ['./batch-list.css'],
  providers: [HistoryActiveService, DatePipe, EvsProductService],
})
export class ModalListBatchChildComponent implements OnInit, OnDestroy {
  /** Lịch sử kích hoạt tem lẻ và dải tem  */
  @ViewChild('select2Api') select2Api;
  @ViewChild('selectAgencyApi') selectAgencyApi;
  @ViewChild('returnStamp') returnStamp: ModalDirective;
  @ViewChild('returnStampList') returnStampList: ModalDirective;
  @ViewChild('cancelStamp') cancelStamp: ModalDirective;
  @ViewChild('editStamp') editStamp: ModalDirective;
  @ViewChild('returnStampBox') returnStampBox: ModalDirective;
  @ViewChild('editLog') editLog: ModalDirective;
  @ViewChild('importFile') importFile: ModalDirective;
  @ViewChild('activeGuarantee') activeGuarantee: ModalDirective;
  @ViewChild('confirmTemplateDownload') confirmTemplateDownload: ModalDirective;
  page_title = 'LỊCH SỬ KÍCH HOẠT/ GÁN SẢN PHẨM';
  isDistributionActive: Boolean = false;
  isList: Boolean = true;
  isReadmore: Boolean = false;
  stasitic: any;
  reason = '';
  lotem: string;
  addContent = '';
  listBatches = [
    {
      label: 'Lo 1',
      value: 1,
    },
    {
      label: 'Lo 2',
      value: 2,
    },
  ];
  data = [];
  data_stamp = [];

  total_data: 0;
  total_stamp: 0;
  item_active_active: any;
  pageIndex = 1;
  // page_size = 10;
  totalPage: number;
  item_detail_active: any;
  dataSelectFromAgency = '';
  dataSelectToAgency = '';
  unsubscribe$ = new Subject<void>();
  query;
  queryStamp = {};
  public fromArea: Array<any> = [];
  public toArea: Array<any> = [];
  formStamp = this.fb.group({
    code: null,
    type: null,
    lotId: null,
    productId: null,
    status: null,
  });
  pageIndexStamp = 1;
  pageSizeStamp = 10;
  supplier = [];
  historyId;
  type_stamp = [
    {
      label: 'Tem thùng',
      value: 0,
    },
    {
      label: 'Tem sản phẩm',
      value: 1,
    },
  ];
  status_stamp = [
    {
      label: 'Đã xác nhận',
      value: 1,
    },
    {
      label: 'Chưa xác nhận',
      value: 0,
    },
  ];
  loading_left = false;
  getCities = [];
  isCheckAll = false;
  listOfChecked = {};
  list_id = [];
  loading_stamp = false;
  disabledConfirm = false;
  disabledReturnBox = false;
  disabledTakeBack = false;
  singleReturnBox = {};
  singleTakeBack = {};
  userIdCreated;
  returnStampBoxImages: any = [];
  boxTypeList: any = [];
  formCratingBatch: FormGroup = this.fb.group({
    name: [''],
    note: [''],
  });
  formWithdrawal: FormGroup = this.fb.group({
    stampCode: ['', [Validators.required]],
  });
  isDownImport: boolean = false;
  batchId: any;
  /**End Lịch sử kích hoạt tem lẻ và dải tem  */


  isUpdate: Boolean = false;
  batch_detail: any;
  closeBtnName: string;
  // public onClose: Subject<boolean>;
  public FormFilterBatchStamp: FormGroup;
  public current_filter: any = {};
  public currentPage: number = 1;
  public page_size: number = 10;
  public totalRow: number = 0;

  public list_items: any = [];
  has_list: boolean = true;
  public item_detail: any = {};
  public item_active: number = 0;
  loadingDetail: boolean = false;
  logs_distribution: any = [];

  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';

  //status batch
  batch_not_pay = 0;
  batch_paid = 1;
  batch_activated = 2;
  is_printing = 1;

  is_chonggia: boolean = false;
  is_baohanh: boolean = false;
  is_tranhang: boolean = false;
  is_dinhdanh: boolean = false;
  isImportChild: boolean = false;

  /*config theo server cho dễ xử lý*/
  code_chonggia = 1;
  code_baohanh = 2;
  code_tranhang = 3;
  code_dinhdanh = 5;

  bsModalDownload: BsModalRef;
  bsModalRef: BsModalRef;
  columns: any = {};

  subcribe: Subscription = null;

  public qrm: string = '';
  isDownloadMapping: boolean = false;
  isDistribution: Boolean = false;
  isDistributionTab2: Boolean = false;
  subcribeChangeSetting: Subscription = null;
  subcribeListEcommerce: Subscription = null;
  listEcommerce: any = [];

  /* Tuanba:12/4/2022: Mekongas*/
  source = Number(JSON.parse(localStorage.getItem('User')).source)
  batch_product_number: any = '';
  is_disable_mekongas: boolean = true;
  password: any;
  user_email: any

  /** [4-11-2022]-Tuanba: Validate button phân phối **/
  @ViewChild('buttonDistribution') buttonDistribution: ModalDirective;
  @ViewChild('warningCancelActive') warningCancelActive: ModalDirective;
  @ViewChild('confirmCancelActive') confirmCancelActive: ModalDirective;
  @ViewChild('boxStampDistribution') boxStampDistribution;
  public errorButtonValidate = '';
  public dataStampHistoryActive: any;
  public checkButtonDistri: any;
  public item_detail2: any

  constructor(
    private batchService: BatchService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private imageService: ImageService,
    public addressService: EvsAddressService,
    public historyActiveService: HistoryActiveService,
    public router: Router,
    private upload: UploadService,
    private activatedRoute: ActivatedRoute,
    public httpClient: HttpClient,
    public datepipe: DatePipe,
    private stampService: EvsStampService,
    private exportService: ExportService,
    private translate: TranslateService,
    private productService: EvsProductService
  ) {
    // this.subcribe = this.modalService.onHide.subscribe((reason: string) => {
    //   this.viewDetail(this.item_active);
    //   // this.viewDetailActive(this,this.item_detail_active);
    // });
  }

  ngOnInit() {
    console.log('batch_detail', this.batch_detail)
    this.is_chonggia = this.batch_detail.is_chonggia;
    this.is_baohanh = this.batch_detail.is_baohanh;
    this.is_tranhang = this.batch_detail.is_tranhang;
    this.is_dinhdanh = this.batch_detail.is_dinhdanh;
    this.isImportChild = this.batch_detail.isImportChild;
    this.loadData();
    this.createFormFilter();
    this.fetch();
    this.getCity()
    // this.onClose = new Subject();

    /** Lịch sử kích hoạt và gán sản phẩm */
    this.initSelect2Translations();
    this.translate.onLangChange.subscribe(() => {
      this.initSelect2Translations();
    });

    // @ts-ignore
    this.loading_left = true;
    const agencyData = JSON.parse(localStorage.getItem('agencyId'));
    // tslint:disable-next-line:prefer-const
    if (agencyData) {
      const newOption = new Option(
        agencyData.name,
        agencyData.id,
        false,
        false
      );
      $('#distributionAgent').append(newOption).trigger('change');
      $('#classify').val('0').trigger('change');
      localStorage.removeItem('agencyId');
    }
    this.getFromArea();
    this.getListBoxType();


    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.batchId = params['id'];
      }
    );
    /** End lịch sử kích hoạt và gán sản phẩm */
  }

  private initSelect2Translations() {
    this.reinitSelect2('#userIdCreated', {
      placeholder: this.translate.instant('NGUOI_THUC_HIEN'),
      allowClear: true,
      minimumInputLength: 1,
      ajax: {
        delay: 1500,
        url: `${environment.qrcode_url}/user/search`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          return {
            keyword: params.term || '',
            page: 1,
            page_size: 50,
          };
        },
        processResults: function (data) {
          if (data.data !== null) {
            return {
              results: data.data.items.map((item) => {
                return {
                  text: item.name,
                  id: item.userId,
                };
              }),
            };
          }
          return [];
        },
      },
    });

    this.reinitSelect2('.slt-batchstamp', {
      placeholder: this.translate.instant('TIM_KIEM_LO_TEM'),
      allowClear: true,
      minimumInputLength: 2,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batch/${this.batch_detail.id}/child`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              // show_parent_child: 1,
            };
          }
          return {
            offset: 0,
            limit: 150,
            // show_parent_child: 1,
          };
        },
        processResults: function (data) {
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  return {
                    text: item.name,
                    id: item.id,
                  };
                })
                : [],
          };
        },
      },
    });

    $('#fromArea').select2({ placeholder: this.translate.instant('KHU_VUC_XUAT'), allowClear: true });
    $('#toArea').select2({ placeholder: this.translate.instant('KHU_VUC_NHAN'), allowClear: true });
    $('#confirmationStatus').select2({
      placeholder: this.translate.instant('TRANG_THAI_XAC_NHAN'),
      allowClear: true,
    });
    $('#alertStatus').select2({
      placeholder: this.translate.instant('TINH_TRANG_CANH_BAO'),
      allowClear: true,
    });
    $('#activeStatus').select2({
      placeholder: this.translate.instant('TRANG_THAI_KICH_HOAT_TEM'),
      allowClear: true,
    });
    $('#approvedFile').select2({
      placeholder: this.translate.instant('TRANG_THAI_GAN_SAN_PHAM'),
      allowClear: true,
    });
  }

  private reinitSelect2(selector: string, options: any) {
    const $el = $(selector);
    if ($el && ($el as any).data('select2')) {
      $el.select2('destroy');
    }
    $el.select2(options);
  }

  /** Lịch sử kích hoạt và gán sản phẩm  */
  productId1;

  changeProduct(event) {
    this.productId1 = event ? event : null;
  }

  listImageDistribution: any = [];

  search() {
    this.pageIndex = 1;
    this.loading_left = true;
    this.fetch();
  }

  closeModalBatchChild() {
    console.log('closeBTN', this.closeBtnName)
  }

  resetActive() {
    console.log('reset');
    localStorage.removeItem('agencyId');
    this.pageIndex = 1;
    $('.serial').val(null).trigger('change');
    $('.codeSMS').val(null).trigger('change');
    $('.noteTemp').val(null).trigger('change');
    $('#activeStatus').val(null).trigger('change');
    $('#approvedFile').val(null).trigger('change');
    $('.timePicker').val(null).trigger('change');
    $('#batchstamp').val(null).trigger('change');
    $('#userIdCreated').val(null).trigger('change');
    this.loading_left = true;
    this.fetch();
  }

  loadDataChild($event: any) {
    this.fetch();
  }

  fetch() {
    const timePicker = $('.timePicker');
    const from_convert = moment(timePicker.val().split('-')[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
    const to_convert = moment(timePicker.val().split('-')[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
    console.log('v1', from_convert);
    console.log('v', to_convert);
    this.query = {
      serial: $('.serial').val(),
      sms: $('.codeSMS').val(),
      note: $('.noteTemp').val(),
      productId: this.productId1 ? this.productId1 : '',
      activeStatus: $('#activeStatus').val(),
      approvedFile: $('#approvedFile').val(),
      batchId: $('.slt-batchstamp').val() ? $('.slt-batchstamp').val() : '',
      createdBy: $('#userIdCreated').val() ? $('#userIdCreated').val() : '',
      from: timePicker.val().split('-')[0] ? from_convert : '',
      to: timePicker.val().split('-')[1] ? to_convert : '',
      page: this.pageIndex,
      pageSize: this.page_size,
      batchParentId: this.batch_detail.id,
    };

    // this.addressService.getCities().subscribe(val => {
    // console.log('val', this.getCities)

    this.historyActiveService.getBatchHistory(this.batchId, this.query).subscribe(
      (res) => {
        if (res.code === 1) {
          this.total_data = res.data.totalElement;
          // console.log(' this.total_data',  this.total_data)
          const listDistribute = [...res.data.items];
          // res.data.items.map((item, key) => {
          //   this.getCities.map((val2) => {
          //     if (item.fromProvinceId === val2.id) {
          //       // tslint:disable-next-line:no-unused-expression
          //       listDistribute[key].fromProvinceId = val2.name;
          //     }
          //     if (item.toProvinceId === val2.id) {
          //       // tslint:disable-next-line:no-unused-expression
          //       listDistribute[key].toProvinceId = val2.name;
          //     }
          //   });
          // });
          this.data = listDistribute;
          console.log('res11', this.data);

          if (this.data.length > 0) {
            this.data.map((item, i) => {
              if (i === 0) {
                this.viewDetailActive(item, i);
              }
            });
          }
          this.loading_left = false;
          return;
        }
        this.total_data = 0;
        this.loading_left = false;
        this.data = [];
        this.toastr.warning(res.message, 'Thông báo:', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      },
      (err) => {
        this.total_data = 0;
        this.loading_left = false;
        this.data = [];
        this.toastr.warning(err.message, 'Thông báo:', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  getFromArea() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.fromArea = citiesList;
      this.toArea = citiesList;
      this.getCities = res.data.cities;

      this.fetch();
    });
  }

  changeReadMore(e) {
    this.isReadmore = e;
  }

  listImage = [];
  firstImage: any;
  batchActionIdDetail: any;

  viewDetailActive(item, i) {
    this.pageIndexStampDetail = 1
    if (this.isDistributionTab2 == true) {
      this.toastr.warning('Thao tác phân phối đã bị hủy', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    this.isDistributionTab2 = false;
    this.item_detail2 = item
    // this.pageIndexLogDistribution = 1;
    this.resetCheckbox();
    this.pageIndexStamp = 1;
    this.item_active_active = i;
    // this.item_detail = item;
    this.query = {
      batchParentId: this.batch_detail.id
    }
    this.batchActionIdDetail = item.batchActionId;
    // @ts-ignore
    this.historyActiveService
      .distributeDetail(this.batchId, item.batchActionId, this.query)
      .subscribe((res) => {
        const listDistribute = res.data;
        this.item_detail_active = listDistribute;

        if (this.item_detail_active && this.item_detail_active.warrantyReminderConfig) {
          const config = this.item_detail_active.warrantyReminderConfig;
          if (config.reminderMaintain) {
            this.item_detail_active.is_maintenance_reminder = config.reminderMaintain.isSelect;
            this.item_detail_active.maintenance_mode = config.reminderMaintain.mode ? config.reminderMaintain.mode.toLowerCase() : null;
            this.item_detail_active.maintenance_cycle = config.reminderMaintain.numberTimeNotify;
            this.item_detail_active.is_extend_maintenance = config.reminderMaintain.reminderContinue;
            this.item_detail_active.extend_limit = config.reminderMaintain.numberOfLimit;
            if (config.reminderMaintain.timeType === 'DAY') this.item_detail_active.maintenance_cycle_unit = 'days';
            if (config.reminderMaintain.timeType === 'MONTH') this.item_detail_active.maintenance_cycle_unit = 'months';
            if (config.reminderMaintain.timeType === 'YEAR') this.item_detail_active.maintenance_cycle_unit = 'years';
          }
          if (config.reminderExpired) {
            this.item_detail_active.is_expired_reminder = config.reminderExpired.isSelect;
            this.item_detail_active.expired_mode = config.reminderExpired.mode ? config.reminderExpired.mode.toLowerCase() : null;
            this.item_detail_active.expired_cycle = config.reminderExpired.numberTimeNotify;
            if (config.reminderExpired.timeType === 'DAY') this.item_detail_active.expired_cycle_unit = 'days';
            if (config.reminderExpired.timeType === 'MONTH') this.item_detail_active.expired_cycle_unit = 'months';
            if (config.reminderExpired.timeType === 'YEAR') this.item_detail_active.expired_cycle_unit = 'years';
          }
        }

        this.checkButtonDistri = res.data.allActive;
        console.log('this.checkButtonDistri', this.checkButtonDistri)
        if (this.item_detail_active.documents == null) {
          console.log(' nul 123123');
          this.listImage = [];
          console.log('res2222', this.listImage);
        } else {
          this.listImage = this.item_detail_active.documents.items;
          console.log(' not nul 123123');
          console.log('res3333', this.listImage);
        }

        this.loadListStamp(item.batchActionId)
        // this.formCratingBatch.controls.name.setValue(this.item_detail.name);
        // this.formCratingBatch.controls.note.setValue(this.item_detail.note);

        // this.listImageDistribution = [];
        // if (this.item_detail.document && this.item_detail.document.items) {
        //   this.item_detail.document.items.map((res) => {
        //     this.listImageDistribution.push({
        //       id: res.id,
        //       url: res.url,
        //     })
        //   })
        // }

        // listImageDistribution
      });

    this.isList = true;
  }

  changeDistribution() {
    if (this.loading_left) {
      this.toastr.warning('Đang tải dữ liệu', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      this.isDistribution = true;
      this.isList = false;
      this.isWithdrawal = false;
      this.resetFormWithdrawal()

    }
  }

  // load page danh sach lịch sử đóng thùng
  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      this.loading_left = true;

      this.fetch();
    }
  }

  lastPageList() {
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )

    // if (this.pageIndex * this.page_size < this.total_data) {
    this.pageIndex = this.pageIndex + 1;
    this.loading_left = true;

    this.fetch();
    // }
  }

  inputPageList(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      this.loading_left = true;

      this.fetch();
    }
  }

  // ============== danh sach tem ========================== //

  pageIndexStampDetail = 1;
  pageSizeStampDetail = 10;

  loadListStamp(id) {
    // this.queryStamp
    this.loading_stamp = true;
    this.queryStamp = {
      page: this.pageIndexStampDetail,
      pageSize: this.pageSizeStampDetail,
      batchParentId: this.batch_detail.id
    };
    console.log('this.queryStamp', this.queryStamp)
    this.historyActiveService
      .historyBatch(this.batchId, id, this.queryStamp)
      .subscribe(
        (res) => {
          if (res.code === 1) {

            this.data_stamp = res.data.items.map((item: any) => {
              let tmpItem = item;
              tmpItem.serialStart = this.formatSerial(
                item.idStart,
                item.prefix
              );
              tmpItem.serialEnd = this.formatSerial(item.idEnd, item.prefix);
              return tmpItem;
            });

            if (this.data_stamp.length > 0) {
              for (let i = 0; i < this.data_stamp.length; i++) {
                if (this.data_stamp[i].services) {
                  var listServices: any = [];
                  var services = this.data_stamp[i].services.split(',');
                  for (let j = 0; j < services.length; j++) {
                    switch (services[j]) {
                      case '1': {
                        listServices.push({
                          id: 1,
                          name: this.translate.instant('CHONG_GIA')
                        })
                        break;
                      }
                      case '2': {
                        listServices.push({
                          id: 2,
                          name: this.translate.instant('BAO_HANH')
                        })
                        break;
                      }
                      case '3': {
                        listServices.push({
                          id: 3,
                          name: this.translate.instant('TRAN_HANG')
                        })
                        break;
                      }
                      case '5': {
                        listServices.push({
                          id: 5,
                          name: this.translate.instant('DINH_DANH')
                        })
                        break;
                      }
                    }
                  }

                }
              }
              this.data_stamp = this.data_stamp.map(z => {
                return {...z, listServices}
              });
            }
            // this.data_stamp.map(console.log);
            this.total_stamp = res.data.pagination.totalElements;
            console.log('toastall', this.data_stamp);
            this.refeshCheckAll();
            this.loading_stamp = false;
            return;
          }
          this.data_stamp = [];
          this.total_stamp = 0;
          this.loading_stamp = false;
        },
        (error) => {
          this.data_stamp = [];
          this.total_stamp = 0;
          this.loading_stamp = false;
        }
      );
  }


  prePageStampDetail() {
    this.pageIndexStampDetail = this.pageIndexStampDetail - 1;
    this.loadListStamp(this.batchActionIdDetail);
  }

  lastPageStampDetail() {
    console.log('this.pageIndexStampDetail * this.pageIndexStampDetail', this.pageIndexStampDetail, this.pageIndexStampDetail)
    if (this.pageIndexStampDetail * this.pageSizeStampDetail < this.total_stamp) {
      this.pageIndexStampDetail = this.pageIndexStampDetail + 1;
      this.loadListStamp(this.batchActionIdDetail);
    }
  }

  inputPageStampDetail(event) {
    // tslint:disable-next-line:radix

    const page = parseInt(event.target.value);
    console.log('page', page)
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexStampDetail) {
      this.pageIndexStampDetail = page;
      this.loadListStamp(this.batchActionIdDetail);
    }
  }

  refeshCheckAll() {
    if (this.data_stamp && this.data_stamp.length) {
      // tslint:disable-next-line:max-line-length
      this.isCheckAll = this.data_stamp.every(
        (item) =>
          this.listOfChecked[
          item.stampId +
          '-' +
          item.stampStatus +
          '-' +
          item.stampType +
          '-' +
          item.prefix +
          '-' +
          item.idStart +
          '-' +
          item.idEnd
            ]
      );
      return;
    }
    this.isCheckAll = false;
  }

  searchStamp() {
    this.pageIndexStamp = 1;
    // this.loadListStamp();
  }

  resetStamp() {
    this.formStamp.reset();
    $('.stampCode').val('').trigger('change');
    $('#typeTemp').val(null).trigger('change');
    $('#productId').val(null).trigger('change');
    $('#confirmation').val(null).trigger('change');
    // $('#stampStatus').val(null).trigger('change');
    this.pageIndexStamp = 1;
    // this.loadListStamp();
  }

  checkALl(event) {
    this.isCheckAll = event.target.checked;
    if (this.isCheckAll) {
      this.data_stamp.map((item) => {
        // tslint:disable-next-line:max-line-length
        this.listOfChecked[
        item.stampId +
        '-' +
        item.stampStatus +
        '-' +
        item.stampType +
        '-' +
        item.prefix +
        '-' +
        item.idStart +
        '-' +
        item.idEnd
          ] = true;
      });
      this.listIdChecked();
      this.checkDisableButton();

      return;
    }
    this.data_stamp.map((item) => {
      // tslint:disable-next-line:max-line-length
      this.listOfChecked[
      item.stampId +
      '-' +
      item.stampStatus +
      '-' +
      item.stampType +
      '-' +
      item.prefix +
      '-' +
      item.idStart +
      '-' +
      item.idEnd
        ] = false;
      this.listIdChecked();
      this.checkDisableButton();
    });
  }

  listIdChecked() {
    for (const key in this.listOfChecked) {
      if (this.listOfChecked[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
  }

  checkBoxChange(event) {
    const checked = event.target.checked;
    const value = event.target.value;

    this.listOfChecked[value] = checked;
    // tslint:disable-next-line:max-line-length
    this.isCheckAll = this.data_stamp.every(
      (item) =>
        this.listOfChecked[
        item.stampId +
        '-' +
        item.stampStatus +
        '-' +
        item.stampType +
        '-' +
        item.prefix +
        '-' +
        item.idStart +
        '-' +
        item.idEnd
          ]
    );
    this.listIdChecked();

    this.checkDisableButton();
  }

  resetCheckbox() {
    this.isCheckAll = false;
    this.listOfChecked = {};
    this.list_id = [];
    this.disabledConfirm = false;
    this.disabledReturnBox = false;
    this.disabledTakeBack = false;
  }

  checkDisableButton() {
    // check disable button
    const checkConfirm = [];
    const checkReturn = [];
    const checkTakeBack = [];
    this.list_id.map((res) => {
      const stampStatus = res.split('-')[1];
      const stamp = res.split('-')[0];
      // tslint:disable-next-line:radix
      if (parseInt(stampStatus) === 1) {
        console.log('stampStatus1', stampStatus);
        checkConfirm.push(stamp);
        checkTakeBack.push(stamp);
      } else {
        console.log('stampStatus2', stampStatus);

        checkReturn.push(stamp);
      }
    });

    this.disabledConfirm = checkConfirm.length > 0;
    this.disabledReturnBox = checkReturn.length > 0;
    this.disabledTakeBack = checkTakeBack.length > 0;
  }

  confirmAll(e?) {
    let body = {};

    if (e) {
      body = {
        listBundleId: [e],
      };
    } else {
      if (this.list_id.length <= 0) {
        this.toastr.warning('Bạn chưa chọn tem', 'Thông báo:', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      const list = [];
      this.list_id.map((res) => list.push(res.split('-')[0]));

      body = {
        listBundleId: list,
      };
    }

    console.log('this.listOfChecked', body);

    this.historyActiveService.confirm(body).subscribe(
      (res) => {
        console.log('res111kkk', res);
        if (res.code === 1) {
          this.isCheckAll = false;
          this.listOfChecked = {};
          this.list_id = [];
          // this.loadListStamp();

          this.toastr.success(
            'Xác nhận thành công' +
            `<div>Thành công: <b>${res.data.success}</b>, Thất bại: <b>${res.data.fail}</b></div>`,
            'Thành công',
            {
              timeOut: 4000,
              positionClass: 'toast-top-right',
              enableHtml: true,
            }
          );
          return;
        }
        this.toastr.warning(res.message, 'Thông báo:', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      },
      (error) => {
        this.toastr.warning(error.message, 'Thông báo:', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  returnBox() {
    // console.log(this.singleReturnBox, _.isEmpty(this.singleReturnBox));

    if (_.isEmpty(this.singleReturnBox)) {
      if (this.list_id.length <= 0) {
        this.toastr.warning('Bạn chưa chọn tem', 'Thông báo:', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
        return;
      }
    }
    this.returnStampBox.show();
  }

  loadingReturnStampBox: boolean = false;

  handleReturnStampBox() {
    console.log('this.list_id', this.list_id);
    if (this.addContent.trim().length === 0) {
      this.toastr.warning('Bạn chưa nhập lý do trả hàng', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (this.addContent.trim().length > 255) {
      this.toastr.warning('Bạn đã nhập quá 255 ký tự', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    let body = {};
    // trả hàng nhiều
    if (_.isEmpty(this.singleReturnBox)) {
      const data = [];
      this.list_id.map((res) => {
        let arrSplit = res.split('-');
        const stampType = arrSplit[2];
        const idEnd = arrSplit[arrSplit.length - 1];
        const idStart = arrSplit[arrSplit.length - 2];
        const indexRemove = [0, 1, 2, arrSplit.length - 1, arrSplit.length - 2];
        const prefix = arrSplit
          .filter(function (value, index) {
            return indexRemove.indexOf(index) == -1;
          })
          .join('-');

        data.push({
          type: stampType,
          prefix: prefix,
          idStart: idStart,
          idEnd: idEnd,
          note: this.addContent,
          document: {
            items:
              this.returnStampBoxImages && this.returnStampBoxImages.length
                ? this.returnStampBoxImages
                : null,
          },
        });
      });
      body = {
        listData: data,
        transferId: this.historyId,
      };
    }
    // trả hàng đơn
    else {
      body = {
        transferId: this.historyId,
        listData: [
          {
            type: this.singleReturnBox['stampType'],
            prefix: this.singleReturnBox['prefix'],
            idStart: this.singleReturnBox['idStart'],
            idEnd: this.singleReturnBox['idEnd'],
            note: this.addContent,
            document: {
              items:
                this.returnStampBoxImages && this.returnStampBoxImages.length
                  ? this.returnStampBoxImages
                  : null,
            },
          },
        ],
      };
    }

    this.loadingReturnStampBox = true;
    this.historyActiveService.return(body).subscribe(
      (res) => {
        if (res.code === 1) {
          this.list_id = [];
          this.listOfChecked = {};
          this.isCheckAll = false;
          this.toastr.success(
            'Trả hàng thành công' +
            `<div>Thành công: <b>${res.data.success}</b>, Thất bại: <b>${res.data.fail}</b></div>`,
            'Thành công',
            {
              timeOut: 4000,
              enableHtml: true,
            }
          );
          this.loadingReturnStampBox = false;
          setTimeout(() => {
            this.addContent = '';
            this.returnStampBoxImages = [];
            this.returnStampBox.hide();
            // this.loadListStamp();
          }, 200);
          return;
        }
        this.loadingReturnStampBox = false;
        this.toastr.error(`${res.message}`, 'Thất bại');
      },
      (error) => {
        this.loadingReturnStampBox = false;
        this.toastr.error(`${error.message}`, 'Thất bại');
      }
    );
  }

  takeBack() {
    if (_.isEmpty(this.singleTakeBack)) {
      if (this.list_id.length <= 0) {
        this.toastr.warning('Bạn chưa chọn tem', 'Thông báo:', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
        return;
      }
    }
    this.returnStamp.show();
  }


  cancel() {
    this.cancelStamp.show();
  }

  showEdit() {
    this.editStamp.show();
  }

  onLoadingReturnStamp: boolean = false;

  handleReturnStamp() {
    console.log('this.list_id', this.list_id);
    return;
    let body = {};
    if (_.isEmpty(this.singleTakeBack)) {
      const data = [];
      this.list_id.map((res) => {
        const stampId = res.split('-')[0];
        data.push({
          bundleId: stampId,
        });
      });

      body = {
        datas: data,
        transferId: this.historyId,
      };
    } else {
      body = {
        datas: [this.singleTakeBack],
        transferId: this.historyId,
      };
    }
    // console.log("body", body);
    this.onLoadingReturnStamp = true;
    console.log(body);
    return
    this.historyActiveService.takeBack(body).subscribe(
      (res) => {
        if (res.code === 1) {
          this.list_id = [];
          this.listOfChecked = {};
          this.isCheckAll = false;
          this.toastr.success(
            'Thu hồi phân phối thành công' +
            `<div>Thành công: <b>${res.data.success}</b>, Thất bại: <b>${res.data.fail}</b></div>`,
            'Thành công',
            {
              timeOut: 4000,
              enableHtml: true,
            }
          );
          setTimeout(() => {
            this.returnStamp.hide();
            // this.loadListStamp();
          }, 200);
          this.onLoadingReturnStamp = false;
          return;
        }
        this.toastr.error(`${res.message}`, 'Thất bại');
        this.onLoadingReturnStamp = false;
      },
      (error) => {
        this.onLoadingReturnStamp = false;
        this.toastr.error(`${error.message}`, 'Thất bại');
      }
    );
  }

  onloadingCancelStamp: boolean = false;

  handleCancelStamp() {
    let body = {
      transferId: this.item_detail.historyId
    }
    this.onloadingCancelStamp = true;
    this.historyActiveService.cancelStamp(body).subscribe(
      (res: any) => {
        console.log(res);
        if (res.code === 1) {
          this.toastr.success('Hủy giao dịch thành công', 'Thành công', {
            timeOut: 4000,
            enableHtml: true,
          });
          setTimeout(() => {
            this.cancelStamp.hide();
            // this.loadListStamp();
            this.resetActive()
          }, 200);
          this.onloadingCancelStamp = false;
          return;
        }
        this.toastr.error(`${res.message}`, 'Thất bại');
        this.onloadingCancelStamp = false;
      },
      (error) => {
        this.onloadingCancelStamp = false;
        this.toastr.error(`${error.message}`, 'Thất bại');
      }
    );
  }

  prePageStamp() {
    this.pageIndexStamp = this.pageIndexStamp - 1;
    // this.loadListStamp();
  }

  lastPageStamp() {
    if (this.pageIndexStamp * this.pageIndexStamp < this.total_stamp) {
      this.pageIndexStamp = this.pageIndexStamp + 1;
      // this.loadListStamp();
    }
  }

  inputPageStamp(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexStamp) {
      this.pageIndexStamp = page;
      // this.loadListStamp();
    }
  }

  // search serial
  searchInfoSerial(code: string) {
    this.router.navigate(['/find-stamp'], {queryParams: {code}});
  }

  // formatSerial(id: any, prefix: string) {
  //   let serial_f: string = '';
  //   id = id.toString();
  //   if (id && prefix) {
  //     let pad = '000000';
  //     let serial = pad.substring(0, 6 - id.length) + id;
  //     serial_f = prefix + '-' + serial;
  //   }
  //   return serial_f;
  // }

  // handle images when upload
  tusUploadReturnBoxImages = (item) => {
    const numberImages = item.target.files.length;
    for (const image of item.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileData = (<any>e.target).result;
        return this.upload.uploadImagesNew(fileData).subscribe((res) => {
          const image = {
            id: res.json().fileId,
            url: res.json().src,
          };
          this.returnStampBoxImages.push(image);
          console.log(this.returnStampBoxImages);
        });
      };
      reader.readAsArrayBuffer(image);
    }
  };

  // delete image upload
  deleteImage(index: number) {
    this.returnStampBoxImages.splice(index, 1);
  }

  changeGuaranteeDays(value) {
    console.log(value);
    if (this.currentLog) {
      // this.currentLog.guaranteeDays = value
    }
  }

  public guaranteeDays;
  public guaranteeDaysMax;
  public produceTime;
  public guaranteeDayMaxType;
  public guaranteeDayType
  currentLogId: any;
  currentLog: any;
  public batchOrderCode: any;
  public isCheck_baohanh: boolean;



  openModalEditLog(item) {
    this.currentLogId = item.id;
    this.guaranteeDays = item.guaranteeDays;
    this.guaranteeDaysMax = item.guaranteeDaysMax;
    this.guaranteeDayType = item.guaranteeDayType;
    this.guaranteeDayMaxType = item.guaranteeDayMaxType;
    this.produceTime = item.produceTime;
    this.batchOrderCode = item.batchOrderCode ? item.batchOrderCode.slice(-9) : ''
    this.batch_product_number = item.batchProductNumber ? item.batchProductNumber : '';

    console.log('id: ', item.listServices);
    if (item.listServices.length > 0) {
      item.listServices.map((res) => {
        if (res.id === 2) {
          this.isCheck_baohanh = true;
        }
      })
    }
    console.log(this.guaranteeDayType);
    this.editLog.show();
  }

  updateBatchLog() {
    console.log('time ', this.produceTime);
    if (typeof this.produceTime === 'string') {
      const dateArr = this.produceTime.split('-');
      this.produceTime = new Date(parseInt(dateArr[2]), parseInt(dateArr[1]) - 1, parseInt(dateArr[0]))
    }
    console.log('1111 ', this.produceTime);
    const time = this.datepipe.transform(this.produceTime, 'dd-MM-yyyy');
    // console.log("type", typeof (time));
    // let time = moment(this.produceTime).format('DD-MM-YYYY');
    console.log('thoi gian ne: ' + time);
    // console.log('aba: ' + this.guaranteeDays, this.guaranteeDaysMax, time, this.currentLogId, this.guaranteeDayMaxType, this.guaranteeDayType);
    const body: any = {
      currentLogId: this.currentLogId,
      produceTime: time, //Ngày sản xuất
      guaranteeDays: this.guaranteeDays, // Thời gian bảo hành
      guaranteeDayType: this.guaranteeDayType, // Kiểu thời gian bảo hành
      guaranteeDaysMax: this.guaranteeDaysMax,
      guaranteeDayMaxType: this.guaranteeDayMaxType,
      batchProductNumber: this.batch_product_number
    }

    if ((body.guaranteeDaysMax)) {
      if ((!body.produceTime || !body.guaranteeDays)) {
        this.toastr.error('Thời gian bảo hành và ngày sản xuất không được để trống', '', {
          timeOut: 1000,
          positionClass: 'toast-bottom-right',
        })
        return;
      }
    }
    this.historyActiveService.updateLogBatch(body.currentLogId, body).subscribe((res) => {
        if (res.code === 1) {
          this.toastr.success('Cập nhật log thành công', 'Thông báo', {
            timeOut: 1000,
            positionClass: 'toast-top-right',
          });
          setTimeout(() => {
            this.fetch()
            this.closeModalEditLog();
          }, 2000);

          return;
        } else if (res.code == 400) {
          this.toastr.error('Không có quyền quản lý với lô tem', 'Thông báo', {
            timeOut: 1000,
            positionClass: 'toast-bottom-right',
          })
          setTimeout(() => {
            this.fetch()
            this.closeModalEditLog();
          }, 2000);
        }
      },
      (error) => {
        console.log('error', error)
        this.toastr.error(error.message, 'Cập nhật thành công', {
          timeOut: 1000,
          positionClass: 'toast-top-right',
        });
        this.fetch()
        this.closeModalEditLog();
      }
    );


  }


  closeModalEditLog() {
    this.editLog.hide();
  }

  /** Tuanba 13/04: Meskong gas */
  public selectedStartDate: any;

  /** Xử lý phần kích hoạt lô tem - tách lô và kích hoạt*/
  updateMyDate(newDate) {
    if (this.source === 2) {
      console.log('newDate', newDate);
      if (newDate !== undefined) {
        if (newDate === null) {
          this.batch_product_number = this.batchOrderCode;
        } else {
          let formatDate = moment(newDate).format('DD-MM');
          let batch_product_number = this.batchOrderCode + '-' + formatDate.replace('-', '');
          this.batch_product_number = batch_product_number;
        }
      }
    }
  }

  getListBoxType() {
    this.historyActiveService.listBoxType().subscribe(
      (res) => {
        if (res.code === 1) {
          this.boxTypeList = res.data.map((item) => {
            return {
              value: item.type,
              label: item.name,
            };
          });
        } else {
          this.boxTypeList = [];
        }
      },
      (err) => {
        this.boxTypeList = [];
        console.log(err);
      }
    );
  }


  pageIndexWarningUser = 1;
  pageSizeWarningUser = 10;
  total_warning_user = 0;
  loadingUserWarning: boolean = false;
  data_warning_user = [];

  resetWarningUser() {
    this.pageIndexWarningUser = 1;
    // $("#Area3").val("").trigger("change");
    // $("#Agency3").val("").trigger("change");
    this.loadDataWarningUser();
  }

  searchWarningUser() {
    this.pageIndexWarningUser = 1;
    this.loadDataWarningUser();
  }

  loadDataWarningUser() {
    let query: any = {
      // keySearch:
      //   $('#serial3').val() && $('#serial3').val().trim() !== ''
      //     ? $('#serial3').val().trim().toUpperCase()
      //     : '',
      // agency: $('#Agency3').val() || '',
      // province: $('#Area3').val() || '',
      from: '',
      to: '',
      page: this.pageIndexWarningUser,
      page_size: this.pageSizeWarningUser,
    };
    // let time = $('#time3').val();
    // if (time) {
    //   query.from = time.split('-')[0].split('/').join('-').trim();
    //   query.to = time.split('-')[1].split('/').join('-').trim();
    // }

    this.loadingUserWarning = true;
    this.historyActiveService.getList(this.historyId, query).subscribe(
      (res) => {
        console.log('res', res)
        if (res.code === 1) {
          if (
            res.data.items !== null ||
            (res.data.items && res.data.items.length > 0)
          ) {
            this.data_warning_user = res.data.items.map((item: any) => {
              const tmpItem = Object.assign({}, item);
              let serial: any;
              if (item.stampCode && item.stampCode.split('-').length) {
                serial = this.formatSerial(
                  item.stampCode.split('-')[1],
                  item.stampCode.split('-')[0]
                );
                tmpItem.serial = serial;
              }

              return tmpItem;
            });
            this.total_warning_user = res.data.totalElement;
            this.loadingUserWarning = false;
            return;
          } else {
            this.data_warning_user = [];
            this.loadingUserWarning = false;
            this.total_warning_user = 0;
          }
        }
        this.data_warning_user = [];
        this.loadingUserWarning = false;
        this.total_warning_user = 0;
      },
      (error) => {
        this.data_warning_user = [];
        this.total_warning_user = 0;
        this.loadingUserWarning = false;
      }
    );
  }

  prePageWarningUser() {
    if (this.pageIndexWarningUser > 1) {
      this.pageIndexWarningUser = this.pageIndexWarningUser - 1;
      this.loadDataWarningUser();
    }
  }

  lastPageWarningUser() {
    if (
      this.pageIndexWarningUser * this.pageSizeWarningUser <
      this.total_warning_user
    ) {
      this.pageIndexWarningUser = this.pageIndexWarningUser + 1;
      this.loadDataWarningUser();
    }
  }

  inputPageWarningUser(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexWarningUser) {
      this.pageIndexWarningUser = page;
      this.loadDataWarningUser();
    }
  }

  listContent = [];
  stampList = [];
  @ViewChild('boxRetalStamps') boxRetalStamps;
  errorMessage = [];
  // groupItems = [];
  isWithdrawal = false

  isNaN(x) {
    // Ép kiểu Number cho biến x
    x = Number(x);
    // Nếu x là NaN, NaN != NaN trả về true, các trường hợp khác sẽ trả về false
    return x != x;
  }

  removeItem(index) {
    this.listContent = this.listContent.filter((res, i) => i !== index);
    this.stampList = this.stampList.filter((res, i) => i !== index);
    console.log(' this.listContent', this.listContent)
    console.log(' this.stampList', this.stampList)

    if (this.stampList.length == 0) {
      this.errorMessage = [];
    } else {
      console.log(' this.stampList', this.stampList)
      console.log('this.errorMessage', this.errorMessage)

      const convertListContent = []
      this.listContent.map((item) => {
        const prefix = item.split('-')[0]
        const number = Number(item.split('-')[1])
        console.log('item', item)
        console.log('prefix', prefix)
        convertListContent.push(`${prefix}-${number}-${number}`)

      })
      this.errorMessage = this.errorMessage.filter((val) => {
        if (val.parent) {
          if (convertListContent.includes(val.parent)) {
            return convertListContent.includes(val.serial)

          } else {
            return false
          }
        } else {
          return convertListContent.includes(val.serial)
        }
      })
    }
    // this.validateWithdrawal()

  }

  showModal() {
    // console
    const data = {
      id: 'myModalCrating',
      title: 'THÊM DANH SÁCH TEM THU HỒI',
      contentMess: 'Bạn chưa nhập tem',
      listContent: [],
    };
    this.boxRetalStamps.show(data);
  }

  loadDataTH(e) {
    console.log('e', e);

    const stampList = [];
    e.map((res) => {
      const splitSerial = res.split('-');
      let _serial: any = '';
      let _prefix: any = '';
      if (splitSerial.length > 1) {
        _serial = splitSerial.pop();
        _prefix = res.split(_serial)[0].slice(0, -1);
      } else {
        _serial = NaN;
        _prefix = splitSerial[0];
      }
      const stamp = {
        prefix: _prefix,
        serialFirst: _serial,
        serialLast: _serial,
      };
      stampList.push(stamp);
    });
    // this.stampList = stampList;
    // console.log(' this.stampList', this.stampList)
    this.validateWithdrawal(stampList)
  }

  timeout: any = null;
  checkboxSigle = false

  changeCheckboxSigle() {
    this.checkboxSigle = $('#checkboxSigle').is(':checked');
    if (this.checkboxSigle) {
      setTimeout(() => {
        $('#checkboxSigleVal').focus();
      }, 100);
    }
  }

  async changeCheckboxSigleValue() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    let tmp = $('#checkboxSigleVal').val();
    if (!tmp) return;
    tmp = tmp[0] + tmp.slice(1);
    $('#checkboxSigleVal').val('');
    this.timeout = setTimeout(async () => {
      let id = '';
      if (tmp.search('http') !== -1 || tmp.search('Http') !== -1) {
        const splitLink = tmp.split('/');
        id = splitLink[splitLink.length - 1];
      } else {
        id = tmp;
      }

      if (id) {
        this.historyActiveService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              this.loadDataTH([val.data]);
            } else {
              this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
          });
      } else {
        this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    }, 0);
    setTimeout(() => {
      $('#checkboxSigleVal').focus();
    }, 100);
  }

  changeWithdrawal() {
    if (this.loading_left) {
      this.toastr.warning('Đang tải dữ liệu', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      this.isDistribution = false;
      this.isList = false;
      this.isWithdrawal = true;
    }
  }

  validateWithdrawal(stampList) {
    // console.log(111, this.stampList);
    if (stampList.length <= 0) {
      this.toastr.warning('Bạn chưa nhập tem', 'Cảnh báo', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    let body = [];
    // this.errorMessage = [];
    stampList.map((res) => {
      body.push({
        prefix: res.prefix,
        idStart: Number(res.serialFirst),
        idEnd: Number(res.serialLast)
      })
    })

    console.log('body', body);
    this.historyActiveService.validateWithdrawal(body).subscribe(
      (res) => {
        console.log(111);
        // this.stampList = []
        res.data.items.map((val) => {
          let check = _.find(this.stampList, {
            prefix: val.takeBackData.prefix,
            serialFirst: val.takeBackData.idStart,
            serialLast: val.takeBackData.idEnd,
            bundleType: val.bundleType,
            listParent: val.listParent,
            takeBackData: val.takeBackData,
            errMsg: val.errMsg,

          })
          if (!check) {
            this.listContent.push(val.takeBackData.stampRequest);
            console.log('this.listContent', this.listContent)
            console.log('val.takeBackData.stampRequest', val.takeBackData.stampRequest)
            this.stampList.push({
              prefix: val.takeBackData.prefix,
              serialFirst: val.takeBackData.idStart,
              serialLast: val.takeBackData.idEnd,
              bundleType: val.bundleType,
              listParent: val.listParent,
              takeBackData: val.takeBackData,
              errMsg: val.errMsg,

            })
          } else {
            this.toastr.warning(`Tem ${val.takeBackData.stampRequest} đã tồn tại trong dải ${val.takeBackData.prefix}-${val.takeBackData.idStart}-${val.takeBackData.idEnd}`, 'Cảnh báo', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }

        })
        console.log(' this.stampList', this.stampList);
        // check trung temp
        const err = []
        this.stampList.map((itemVal) => {
          if (res.code === 1) {
            if (itemVal.errMsg) {
              err.push({
                parent: '',
                serial: `${itemVal.takeBackData.prefix}-${itemVal.takeBackData.idStart}-${itemVal.takeBackData.idEnd}`,
                mess: `${itemVal.errMsg}`,
              })
            }
          }

          if (itemVal.listParent.length > 0) {
            itemVal.listParent.map((itemParent) => {
              const checkTr = _.find(this.stampList, {
                'prefix': itemParent.prefix,
                'serialFirst': itemParent.number,
                'serialLast': itemParent.number
              });
              if (checkTr) {
                err.push({
                  parent: `${itemParent.prefix}-${itemParent.number}-${itemParent.number}`,
                  serial: `${itemVal.takeBackData.prefix}-${itemVal.takeBackData.idStart}-${itemVal.takeBackData.idEnd}`,
                  mess: `Tem con ${itemVal.takeBackData.prefix}-${itemVal.takeBackData.idStart}-${itemVal.takeBackData.idEnd} đã thuộc Tem cha ${itemParent.prefix}-${itemParent.number}-${itemParent.number}`,
                })
              }
              console.log('checkTr', checkTr)

            })
          }
          this.errorMessage = err
        })

        if (res.code === 1) {
          // this.stampList.map((val) => {
          //   if (val.errMsg) {
          //     this.errorMessage.push({
          //       serial: `${val.takeBackData.stampRequest}`,
          //       mess: `${val.errMsg}`,
          //     })
          //   }
          //
          // })


          // this.stampList = stampList;
          // if (this.errorMessage.length === 0) {
          //   this.listContent = [];
          //   this.stampList = [];
          //   this.toastr.success('Cập nhật thành công', 'Thông báo', {
          //     timeOut: 3000,
          //     positionClass: 'toast-top-right',
          //   });
          // }

          // this.reset(this.formCratingBatch.value.is_cratingStamps);
          // this.loadDataParent.emit(true);
        } else {
          this.toastr.warning(res.message, 'Cảnh báo', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }
      },
      (error) => {
        this.toastr.warning(`${error.message}`, 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    );
    // }
  }

  takeBackList() {
    // if (_.isEmpty(this.singleTakeBack)) {
    //   if (this.list_id.length <= 0) {
    //     this.toastr.warning('Bạn chưa chọn tem', 'Thông báo:', {
    //       timeOut: 4000,
    //       positionClass: 'toast-top-right',
    //     });
    //     return;
    //   }
    // }
    this.returnStampList.show();
  }

  resetFormWithdrawal() {
    this.formWithdrawal.reset();
    this.checkboxSigle = false
    this.listContent = [];
    this.stampList = [];
    this.errorMessage = [];
  }

  submitFormWithdrawal() {
    console.log(111, this.stampList);
    if (this.stampList.length <= 0) {
      this.toastr.warning('Bạn chưa nhập tem', 'Cảnh báo', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (this.errorMessage.length > 0) {
      this.toastr.warning('Tem lỗi chưa được xử lý', 'Thông báo', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    let body = [];
    this.stampList.map((res) => {
      body.push({
        prefix: res.prefix,
        idStart: Number(res.serialFirst),
        idEnd: Number(res.serialLast),
        bundleType: Number(res.bundleType)

      })
    })

    console.log('body', body);
    // return;
    this.historyActiveService.withdrawal({items: body}).subscribe(
      (res) => {
        if (res.code === 1) {
          this.returnStampList.hide()
          this.listContent = [];
          this.stampList = [];
          if (res.data.fail > 0) {
            this.toastr.warning(`Cập nhật thành công ${res.data.success}, thất bại ${res.data.fail}`, 'Cảnh báo', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          } else {
            this.toastr.success(`Cập nhật thành công ${res.data.success}, thất bại ${res.data.fail}`, 'Thông báo', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }

          this.formWithdrawal.reset();
        } else {
          this.toastr.warning(res.message, 'Cảnh báo', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }
      },
      (error) => {
        this.toastr.warning(`${error.message}`, 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    );
    // }
  }

  // bsModalDownload: BsModalRef;
  showDownloadBatchActive(templateDownload) {
    this.bsModalDownload = this.modalService.show(templateDownload);
  }

  downloadBatchAcitve() {
    const timePicker = $('.timePicker2');
    let timeData = {
      startDate: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim()
        : '',
      endDate: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim()
        : '',
    }
    if (!timePicker.val()) {
      this.toastr.warning('Bạn chưa chọn thời gian', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      this.batchService.getTokenDownloadBatchPP(timeData).subscribe((data) => {
        data._body.text().then((val) => {
          console.log('data', val)
          if (/^[\],:{}\s]*$/.test(val.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

            this.toastr.warning(`${JSON.parse(val).message}`, 'Cảnh báo', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            //the json is ok
            console.log(1111)
          } else {
            console.log(22222)
            this.batchService.saveToFileSystem(data, 'application/vnd.ms-excel', 'Danh sách phân phối.xlsx')

            //the json is not ok

          }
        })
      });
    }
  }

  /** End lịch sử kích hoạt và gán sản phẩm */


  // getListEcommerce(id) {
  //   this.subcribeListEcommerce = this.batchService
  //     .listEcommerce(id)
  //     .subscribe((res: any) => {
  //       this.listEcommerce = res.data.items
  //     })
  // }

  changeSetting(productLinkId) {
    const dataElement = `input[name="ecommerceCheckbox${productLinkId}"]:checked`
    const body = {status: $(dataElement).serialize() ? 1 : 0}
    this.subcribeChangeSetting = this.batchService
      .changeSetting(this.list_items[this.item_active].id, productLinkId, body)
      .subscribe((res: any) => {
        console.log(res)
        if (res.code === 1) {
          this.toastr.success('Thay đổi trạng thái thành công', 'Thành công:', {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
      })
  }


  ngOnDestroy() {
    if (this.subcribe) {
      this.subcribe.unsubscribe();
    }
  }

  createFormFilter() {
    this.FormFilterBatchStamp = this.fb.group({
      service: [null],
      created_time_ranger: [null],
      name: [null],
    });
  }

  ResetFormSearch() {
    $('#filter_service').selectpicker('val', '');
    this.FormFilterBatchStamp.reset();
    // this.loadData()
  }

  public loadData(request: any = null) {
    let data_get: any = request ? request : this.current_filter;
    if (this.currentPage < 0) {
      this.currentPage = 1;
    }
    data_get.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    data_get.limit = this.page_size;
    this.batchService
      .getListBatchChild(this.batch_detail.id, data_get)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let list: any = [];
          for (let _data of res.data.batches) {
            let obj = {
              id: _data.id,
              name: _data.name,
              quantity: _data.quantity,
              active_left: _data.active_left,
              total_activated:
                _data.active_left == null
                  ? 0
                  : _data.quantity - _data.active_left,
              status: _data.status,
              is_printing: _data.is_printing,
              image: _data.image,
              created_time: moment(_data.created_time).format('DD/MM/YYYY'),
            };
            list.push(obj);
          }

          this.item_active = 0;
          if (list.length > 0) {
            this.has_list = true;
            this.list_items = list;
            this.viewDetail(0);
          } else {
            this.has_list = false;
            this.item_detail = null;
            this.list_items = [];
          }
        } else {
          console.log('getListBatchChild:error', res);
        }
      })
      .catch((err: any) => {
        console.log('getListBatchChild:error', err);
      });
  }

  batchId1: any

  public viewDetail(i) {
    // this.qrm = '';

    this.pageIndexLogDistribution = 1;
    this.item_active = i;
    this.loadingDetail = true;

    if (this.isUpdate == true) {
      this.toastr.warning('Thao tác sửa lô tem đã bị hủy', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    this.isUpdate = false;
    if (this.isDistribution == true) {
      this.toastr.warning('Thao tác phân phối đã bị hủy', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    this.isDistribution = false;

    $('.page-layout-detail').animate(
      {scrollTop: 0},
      0,
      'swing',
      function () {
      }
    );
    this.batchId1 = this.list_items[i].id;
    console.log('this.batchId1', this.batchId1)
    // get detail batch
    if (this.list_items.length > 0) {
      this.batchService
        .getBatchDetail(this.list_items[i].id)
        .toPromise()
        .then((res: any) => {
          if (res.error == false) {
            this.qrm = environment.domainQrcode + res.data.qrm_start;
            //get log phan phoi
            this.getLogDistribution(this.list_items[i].id);
            // this.getListEcommerce(res.data.id);

            // xu ly detail
            this.loadingDetail = false;
            let arr_services = this.convertServiceToText(res.data.services);
            this.item_detail = {
              name: res.data.name,
              point: res.data.point,
              id: res.data.id,
              created_time: res.data.created_time,
              created_time_f: moment(res.data.created_time).format(
                'DD/MM/YYYY'
              ),
              produce_time: res.data.produce_time,
              produce_time_f: moment(res.data.produce_time).format(
                'DD/MM/YYYY'
              ),
              guarantee_days: res.data.guarantee_days,
              guarantee_days_max: res.data.guarantee_days_max,
              guarantee_days_update: res.data.guarantee_days_update,
              guarantee_days_max_update: res.data.guarantee_days_max_update,
              quantity: res.data.quantity,
              arr_services: arr_services,
              buy_services: res.data.buy_services,
              id_start: res.data.id_start,
              id_end: res.data.id_end,
              prefix_id: res.data.prefix_id,
              prefix: res.data.prefix,
              serial:
                this.formatSerial(res.data.id_start, res.data.prefix) +
                ' – ' +
                this.formatSerial(res.data.id_end, res.data.prefix),
              serial_start: this.formatSerial(
                res.data.id_start,
                res.data.prefix
              ),
              status: res.data.status,
              is_printing: res.data.is_printing,
              counter: res.data.counter,
              counter_warning: res.data.counter_warning,
              only_icheck: res.data.only_icheck,
              product_id: res.data.product_id,
              product_name: res.data.product_name,
              product_image: this.imageService.readSrcImage(
                res.data.product_image,
                'thumb_medium'
              ),
              is_chonggia: this.checkService(
                res.data.services,
                this.code_chonggia
              ),
              is_baohanh: this.checkService(
                res.data.services,
                this.code_baohanh
              ),
              is_tranhang: this.checkService(
                res.data.services,
                this.code_tranhang
              ),
              is_dinhdanh: this.checkService(
                res.data.services,
                this.code_dinhdanh
              ),

              is_manufacturer: res.data.is_manufacturer,
              show_vendor: res.data.show_vendor,
              show_distributor: res.data.show_distributor,
              messages: res.data.messages,
              has_child: res.data.active_left != null,
              active_left: res.data.active_left,
              last_imported: res.data.last_imported
                ? moment(res.data.last_imported).format('DD/MM/YYYY')
                : null,
              quantity_imported: res.data.quantity_imported
                ? res.data.quantity_imported
                : 0,
              user_created_name: res.data.user_created_name,
              suggest_apps: res.data.suggest_apps,
              active_buy_online: res.data.active_buy_online,
              type_guarantee_day: res.data.type_guarantee_day,
              type_guarantee_day_max: res.data.type_guarantee_day_max,
              location_type: res.data.location_type,
              option_need_profile: res.data.option_need_profile,
              time_alert: res.data.time_alert,
              time_alert_type: res.data.time_alert_type,
              code: res.data.code != null ? res.data.code : '',
              counter_scan: res.data.counter_scan ? res.data.counter_scan : null,
              counter_scan_warning: res.data.counter_scan_warning ? res.data.counter_scan_warning : null,
              batch_config: res.data.batch_config
            };
            console.log(this.item_detail);
            // fix list when close popup
            this.list_items[i].created_time = this.item_detail.created_time_f;

            //update list when close popup
            this.list_items[i].name = this.item_detail.name;
            this.list_items[i].quantity = this.item_detail.quantity;
            this.list_items[i].arr_services = this.item_detail.arr_services;
            this.list_items[i].status = this.item_detail.status;
            this.list_items[i].image = this.imageService.readSrcImage(
              this.item_detail.product_image,
              'thumb_medium'
            );
            this.list_items[i].total_activated =
              this.item_detail.active_left == null
                ? 0
                : this.item_detail.quantity - this.item_detail.active_left;
          } else {
            console.log('getBatchDetail:error', res);
          }
        })
        .catch((err) => {
          console.log('getBatchDetail:catch:', err);
        });
    }
  }

  checkService(services_list: string, code_service: any) {
    return services_list.indexOf(code_service.toString()) != -1;
  }

  convertServiceToText(service: string) {
    let arr_services: Array<{ code: number; name: string }> = [];
    if (service.indexOf(this.code_chonggia.toString()) != -1) {
      arr_services.push({code: this.code_chonggia, name: this.translate.instant('CHONG_GIA')});
    }
    if (service.indexOf(this.code_baohanh.toString()) != -1) {
      arr_services.push({code: this.code_baohanh, name: this.translate.instant('BAO_HANH')});
    }
    if (service.indexOf(this.code_tranhang.toString()) != -1) {
      arr_services.push({code: this.code_tranhang, name: this.translate.instant('TRAN_HANG')});
    }
    if (service.indexOf(this.code_dinhdanh.toString()) != -1) {
      arr_services.push({code: this.code_dinhdanh, name: this.translate.instant('DINH_DANH')});
    }
    return arr_services;
  }

  showUpdate() {
    this.isUpdate = true;
    clickTracking('qcheck_batch_detail', 'batch_update', 'qcheck_batch_update', '');
    enterScreenView('qcheck_batch_update', 'batch_update', '')
  }

  hideCreate(event) {
    this.isUpdate = false;
    if (event.isBack == false) {
      // delete this.arr_sort['created_time'];
      // this.setSort('created_time', 'desc');
      this.current_filter = {};
      this.currentPage = 1;
      this.loadData();
    }
    if (event.updated == true) {
      this.viewDetail(this.item_active);
    }
  }

  showPopupDistribution() {
    this.isDistribution = true;
    // this.onClose.next(true);
    //
    // const initialState = {
    //   batch_detail: this.item_detail,
    // };
    // this.bsModalRef = this.modalService.show(ModalDistributionComponent, {
    //   initialState,
    // });
    // this.bsModalRef.content.closeBtnName = "Bỏ qua";
  }

  pageIndexLogDistribution = 1;
  pageSizeLogDistribution = 10;
  total_data_logDistribution = 0;

  getLogDistribution(batch_id: number) {
    if (batch_id) {
      let query: any = {};
      query.page = this.pageIndexLogDistribution;
      query.page_size = this.pageSizeLogDistribution;
      this.batchService
        .getDistributionOfBatch(batch_id, query)
        .toPromise()
        .then((res: any) => {
          if (res.data.items && res.data.items.length > 0) {
            let list: any = [];

            for (let _data of res.data.items) {
              let obj = {
                serial:
                  this.formatSerial(_data.id_start, _data.prefix) +
                  ' – ' +
                  this.formatSerial(_data.id_end, _data.prefix),
                address: _data.address,
                district: _data.districts,
                city: _data.provinces,
                created_time: moment(_data.created_time).format('DD-MM-YYYY'),
              };
              list.push(obj);
            }
            this.total_data_logDistribution = res.data.totalElement
            this.logs_distribution = list;
          } else {
            this.logs_distribution = [];
            console.log('getDistribution:error', res);
          }
        })
        .catch((err: any) => {
          console.log('getDistribution:catch', err);
        });
    } else {
      this.logs_distribution = [];
    }
  }

  // phân trang log phân phối

  prePageLogDistribution() {

    if (this.pageIndexLogDistribution > 1) {
      console.log('tuanba', this.batchId);
      this.pageIndexLogDistribution = this.pageIndexLogDistribution - 1;
      this.getLogDistribution(this.batchId1);
    }
  }

  lastPageLogDistribution() {

    if (this.pageIndexLogDistribution * this.pageSizeLogDistribution < this.total_data_logDistribution) {
      console.log('tuanba', this.batchId);
      this.pageIndexLogDistribution = this.pageIndexLogDistribution + 1;
      this.getLogDistribution(this.batchId1);

    }
  }

  inputPageLogDistributionChange(event) {
    console.log('tuanba', this.batchId);
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexLogDistribution) {
      console.log(666);
      this.pageIndexLogDistribution = page;
      this.getLogDistribution(this.batchId1);
    }
  }

  // Phân trang
  setPage(page: number) {
    if (page < 1) {
      this.currentPage = 1;
      return;
    }
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.loadData();
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    } else {
      this.setPage(1); //toPage = 1;
    }
  }

  formatSerial(id, prefix) {
    let serial_f: string = '';
    id = id.toString();
    if (id && prefix) {
      let pad = '000000';
      let serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }

  setSort(sort: string) {
    if (sort) {
      this.current_filter.sort_by = sort;
      this.loadData();
    }
  }

  isPrinting() {
    // this.confirmationService.confirm({
    //   message: `
    //   <div class="text-center">
    //     Xác nhận in lô tem:<br> "<strong>` + this.item_detail.name + `</strong>"
    //   </div>
    //   `,
    //   header: 'In tem',
    //   // icon: 'wb-payment',
    //   accept: () => {
    //
    //   }
    // });
    // Khỏi cần confirm bên trên
    this.batchService
      .setBatchPrinting(this.item_detail.id, {is_printing: 1})
      .subscribe(
        (res: any) => {
          if (res.error === false) {
            this.list_items[this.item_active].is_printing = 1;
            this.item_detail.is_printing = 1;
            let mess = 'Lô tem của bạn đã chuyển sang trạng thái đang in';
            this.toastr.success(mess, 'Thành công:', {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
          } else {
            let mess = res.message
              ? res.message
              : 'Thao tác chưa thành công. Vui lòng thử lại sau!';
            this.toastr.warning(mess, 'Thông báo:', {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
          }
        },
        (err: any) => {
          let mess = err.message
            ? err.message
            : 'Thao tác chưa  thành công. Vui lòng thử lại sau!';
          this.toastr.error(mess, 'Thông báo:', {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
      );
  }

  cancelPrinting() {
    this.batchService
      .setBatchPrinting(this.item_detail.id, {is_printing: 0})
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          this.list_items[this.item_active].is_printing = 0;
          this.item_detail.is_printing = 0;
          let mess = 'Yều cầu dừng in tem thành công';
          this.toastr.success(mess, 'Thành công:', {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        } else {
          let mess = res.message
            ? res.message
            : 'Thao tác chưa thành công. Vui lòng thử lại sau!';
          this.toastr.warning(mess, 'Thông báo:', {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
          console.log('setBatchPrinting:error', res);
        }
      })
      .catch((err: any) => {
        let mess = 'Thao tác chưa thành công. Vui lòng thử lại sau!';
        this.toastr.warning(mess, 'Thông báo:', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
        console.log('setBatchPrinting:error', err);
      });
  }

  showPopupCancelStamp() {
    const initialState = {
      batch_detail: this.item_detail,
    };
    this.bsModalRef = this.modalService.show(ModalCancelStampComponent, {
      initialState,
    });
    this.bsModalRef.content.closeBtnName = 'Bỏ qua';
  }

  showDownloadBatch(templateDownload, isMapping?: any) {
    this.bsModalDownload = this.modalService.show(templateDownload);
    this.isDownloadMapping = isMapping;
    // this.getPasswordEmailDownloadBatch()
  }

  downloadBatch() {
    if (Object.keys(this.columns).length <= 0) {
      this.toastr.warning('Phải chọn ít nhất một cột', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      const typeTrackingPayload = []
      for (const [key, value] of (<any>Object).entries(this.columns)) {
        if (value === true) {
          typeTrackingPayload.push(key);
        }
      }
      clickTracking('form_batch_download', 'download_submit', '', typeTrackingPayload.toString());
      const currentBatch = this.item_detail;
      const request: any = {};
      if (this.isDownImport) {
        console.log(123121321321)
        request.start = currentBatch.id_start;
        request.end = currentBatch.id_end;
        request.prefix_id = currentBatch.prefix_id; // dm, cai nay nhớ là prefix_id nhé, đéo phải batch_id như ở link download bên dưới đâu nhé. LOL.@chuongnv
        request.prefix = currentBatch.prefix;
        request.fields = '&fields=';
        if (this.columns.serial) {
          request.fields += 'serial';
        }
        if (this.columns.qrm) {
          if (request.fields.length <= 0) {
            request.fields += 'qrm';
          } else {
            request.fields += ',qrm';
          }
        }
        if (this.columns.qri) {
          if (request.fields.length <= 0) {
            request.fields += 'qri';
          } else {
            request.fields += ',qri';
          }
        }
        if (this.columns.sms) {
          if (request.fields.length <= 0) {
            request.fields += 'sms';
          } else {
            request.fields += ',sms';
          }
        }
        // let ext = 'xlsx';
        // let filename = '#'+this.item_detail.id+'_'+this.item_detail.name+'.'+ext;
        let query =
          '?start=' + request.start + '&end=' + request.end + request.fields;
        if (localStorage.getItem('Access-Token')) {
          query += '&Access_Token=' + localStorage.getItem('Access-Token');
        }
        console.log('query', query);
        const url = environment.linkDownloadBatchVer2 + query;
        console.log('url', url);
        // let url =
        //   environment.api_evs +
        //   '/stamps/batch/' +
        //   currentBatch.id +
        //   '/download' +
        //   query;
        // console.log('url', url)

        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        // a.target = '_blank'
        a.click();
        // window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
        this.columns = {};
      } else {
        this.batchService
          .getTokenDownloadBatch(this.item_detail.prefix_id.toString())
          .toPromise()
          .then((res: any) => {
            console.log('tuandayy', res)
            if (!res.error && res.data.token_access) {
              request.start = currentBatch.id_start;
              request.end = currentBatch.id_end;
              request.prefix_id = currentBatch.prefix_id; // dm, cai nay nhớ là prefix_id nhé, đéo phải batch_id như ở link download bên dưới đâu nhé. LOL
              request.prefix = currentBatch.prefix;
              request.domain = environment.domainQrcode;
              request.fields = '';
              if (this.columns.serial) {
                request.fields += 'serial';
              }
              if (this.columns.qrm) {
                if (request.fields.length <= 0) {
                  request.fields += 'qrm';
                } else {
                  request.fields += ',qrm';
                }
              }
              if (this.columns.qri) {
                if (request.fields.length <= 0) {
                  request.fields += 'qri';
                } else {
                  request.fields += ',qri';
                }
              }
              if (this.columns.sms) {
                if (request.fields.length <= 0) {
                  request.fields += 'sms';
                } else {
                  request.fields += ',sms';
                }
              }
              // let ext = 'xlsx';
              // let filename = '#'+this.item_detail.id+'_'+this.item_detail.name+'.'+ext;
              const query =
                '?start=' +
                request.start +
                '&end=' +
                request.end +
                '&batch_id=' +
                request.prefix_id +
                '&prefix=' +
                request.prefix +
                '&fields=' +
                request.fields +
                '&domain=' +
                request.domain +
                '&access_token=' +
                res.data.token_access;
              const url = environment.linkDownloadBatchVer2 + query;
              console.log('urrrsadasd', url)
              const a = document.createElement('a');
              document.body.appendChild(a);
              a.setAttribute('style', 'display: none');
              a.href = url;
              const fileName = 'sample1111';
              a.download = fileName
              // a.target = '_blank'
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove(); // remove the element
              this.columns = {};
            } else {
              console.log('getTokenDownloadBatch:error', res);
              this.toastr.warning(
                'Tải về không thành công, vui lòng thử lại sau !',
                'Thông báo:',
                {
                  timeOut: 4000,
                  positionClass: 'toast-top-right',
                }
              );
            }
          })
          .catch((err: any) => {
            console.log('getTokenDownloadBatch:catch', err);
            this.toastr.warning(
              'Tải về không thành công, vui lòng thử lại sau !',
              'Thông báo:',
              {
                timeOut: 4000,
                positionClass: 'toast-top-right',
              }
            );
          });
      }
    }
  }

  // downloadBatch() {
  //   if (Object.keys(this.columns).length <= 0) {
  //     this.toastr.warning('Phải chọn ít nhất một cột', 'Thông báo:', {
  //       timeOut: 4000,
  //       positionClass: 'toast-top-right',
  //     });
  //   } else {
  //     // this.is_downloading_batch = true;
  //     let currentBatch = this.item_detail;
  //     let request: any = {};
  //     if (this.isDownloadMapping) {
  //       request.start = currentBatch.id_start;
  //       request.end = currentBatch.id_end;
  //       request.prefix_id = currentBatch.prefix_id; // dm, cai nay nhớ là prefix_id nhé, đéo phải batch_id như ở link download bên dưới đâu nhé. LOL.@chuongnv
  //       request.prefix = currentBatch.prefix;
  //       request.fields = '&fields=';
  //       if (this.columns.serial) {
  //         request.fields += 'serial';
  //       }
  //       if (this.columns.qrm) {
  //         if (request.fields.length <= 0) {
  //           request.fields += 'qrm';
  //         } else {
  //           request.fields += ',qrm';
  //         }
  //       }
  //       if (this.columns.qri) {
  //         if (request.fields.length <= 0) {
  //           request.fields += 'qri';
  //         } else {
  //           request.fields += ',qri';
  //         }
  //       }
  //       if (this.columns.sms) {
  //         if (request.fields.length <= 0) {
  //           request.fields += 'sms';
  //         } else {
  //           request.fields += ',sms';
  //         }
  //       }
  //       // let ext = 'xlsx';
  //       // let filename = '#'+this.item_detail.id+'_'+this.item_detail.name+'.'+ext;
  //       let query =
  //         '?start=' + request.start + '&end=' + request.end + request.fields;
  //       if (localStorage.getItem('Access-Token')) {
  //         query += '&Access_Token=' + localStorage.getItem('Access-Token');
  //       }
  //       let url =
  //         environment.api_evs +
  //         '/stamps/batch/' +
  //         currentBatch.id +
  //         '/download' +
  //         query;
  //
  //       let a = document.createElement('a');
  //       document.body.appendChild(a);
  //       a.setAttribute('style', 'display: none');
  //       a.href = url;
  //       a.click();
  //       window.URL.revokeObjectURL(url);
  //       a.remove(); // remove the element
  //       this.columns = {};
  //     } else {
  //       this.batchService
  //         .getTokenDownloadBatch(this.item_detail.prefix_id.toString())
  //         .toPromise()
  //         .then((res: any) => {
  //           if (!res.error && res.data.token_access) {
  //             request.start = currentBatch.id_start;
  //             request.end = currentBatch.id_end;
  //             request.prefix_id = currentBatch.prefix_id; // dm, cai nay nhớ là prefix_id nhé, đéo phải batch_id như ở link download bên dưới đâu nhé. LOL
  //             request.prefix = currentBatch.prefix;
  //             request.domain = environment.domainQrcode;
  //             request.fields = '';
  //             if (this.columns.serial) {
  //               request.fields += 'serial';
  //             }
  //             if (this.columns.qrm) {
  //               if (request.fields.length <= 0) {
  //                 request.fields += 'qrm';
  //               } else {
  //                 request.fields += ',qrm';
  //               }
  //             }
  //             if (this.columns.qri) {
  //               if (request.fields.length <= 0) {
  //                 request.fields += 'qri';
  //               } else {
  //                 request.fields += ',qri';
  //               }
  //             }
  //             if (this.columns.sms) {
  //               if (request.fields.length <= 0) {
  //                 request.fields += 'sms';
  //               } else {
  //                 request.fields += ',sms';
  //               }
  //             }
  //             let ext = 'xlsx';
  //             // let filename = '#'+this.item_detail.id+'_'+this.item_detail.name+'.'+ext;
  //             let query =
  //               '?start=' +
  //               request.start +
  //               '&end=' +
  //               request.end +
  //               '&batch_id=' +
  //               request.prefix_id +
  //               '&prefix=' +
  //               request.prefix +
  //               '&fields=' +
  //               request.fields +
  //               '&domain=' +
  //               request.domain +
  //               '&access_token=' +
  //               res.data.token_access;
  //             let url = environment.linkDownloadBatch + query;
  //
  //             let a = document.createElement('a');
  //             document.body.appendChild(a);
  //             a.setAttribute('style', 'display: none');
  //             a.href = url;
  //             a.click();
  //             window.URL.revokeObjectURL(url);
  //             a.remove(); // remove the element
  //             this.columns = {};
  //           } else {
  //             console.log('getTokenDownloadBatch:error', res);
  //             this.toastr.warning(
  //               'Tải về không thành công, vui lòng thử lại sau !',
  //               'Thông báo:',
  //               {
  //                 timeOut: 4000,
  //                 positionClass: 'toast-top-right',
  //               }
  //             );
  //           }
  //         })
  //         .catch((err: any) => {
  //           console.log('getTokenDownloadBatch:catch', err);
  //           this.toastr.warning(
  //             'Tải về không thành công, vui lòng thử lại sau !',
  //             'Thông báo:',
  //             {
  //               timeOut: 4000,
  //               positionClass: 'toast-top-right',
  //             }
  //           );
  //         });
  //     }
  //   }
  // }

  submitFilterBatch(data: any = {}) {
    this.currentPage = 1;
    let data_filter: any = {};

    if (data.name) {
      data_filter.name = data.name;
    }
    if (data.created_time_ranger) {
      data_filter.from = moment(data.created_time_ranger[0]).format(
        'YYYY-MM-DD'
      );
      data_filter.to = moment(data.created_time_ranger[1]).format('YYYY-MM-DD');
    }

    this.current_filter = data_filter;
    this.loadData();
  }

  activeTab = 1;

  changeTab(event) {
    this.activeTab = event;
    if (event === 1) {
      visibleContent('qcheck_batch_detail', 'qcheck_batch_child', 'others')
      this.isDistributionTab2 = false
      this.resetActive();
      this.loadData();
    }
    if (event === 2) {
      visibleContent('qcheck_batch_detail', 'qcheck_batch_separate', 'others')
      this.isDistribution = false
      this.resetActive();
    }
    if (event === 3) {
      // this.resetWarningUser();
    }
    // this.districts = [];
  }

  /** Lịch sử kích hoạt và gán sản phẩm */

  /** End Lịch sử kích hoạt và gán sản phẩm */

  showPopupLogsActiveBatchChild() {

  }

  confirm_paid() {

  }

  showPopupActivePrint() {

  }

  /**[4-11-2022]: Tuanba Phân phối**/

  validateCheckButtonDistribution(item_detail) {
    console.log('itema', item_detail, this.batch_detail.id)
    this.historyActiveService.validateButtonDistributionDetail(item_detail.batchActionId, this.batch_detail.id).subscribe((res) => {
      if (res.code !== 1) {
        this.errorButtonValidate = res.message
        this.buttonDistribution.show();
      } else {
        this.dataStampHistoryActive = res.data.items;
        this.dataStampHistoryActive.map((res) => {
          this.formatSerial(res.idStart, res.prefix)
          this.formatSerial(res.idEnd, res.prefix)
        })
        this.isDistributionTab2 = true;
        setTimeout(() => {
          this.boxStampDistribution.setData2(
            this.dataStampHistoryActive,
            this.dataStampHistoryActive[0].bundleType
          );
        }, 500);
      }
    }, (error) => {
      this.toastr.error(error.message, 'Thông báo', {
        timeOut: 4000,
        positionClass: 'toast-top-right'
      })
    })
  }

  /** TuanBA-8/5/2023:Modal Hủy kích hoạt **/
  public detailStamp: any;

  openModalCancelActive(item: any) {
    this.confirmCancelActive.show();
    this.detailStamp = item.id
  }

  closeModalCancelActive(param: any) {
    if (param === 'warning') {
      this.warningCancelActive.hide();
    } else {
      this.confirmCancelActive.hide();
    }
  }

  confirmModalCancelActive() {
    this.historyActiveService.deleteStamp(this.detailStamp).subscribe((res) => {
      if (res.status === 200) {
        if (res.code === 1) {
          this.toastr.error('Xóa thành công', 'Thông báo', {
            timeOut: 3000, positionClass: 'toast-bottom-right',
          })
          this.confirmCancelActive.hide();
        } else if (res.code === 403) {
          this.toastr.error(res.message, 'Thông báo', {
            timeOut: 3000, positionClass: 'toast-bottom-right',
          })
          this.confirmCancelActive.hide();
        } else {
          this.confirmCancelActive.hide();
          this.warningCancelActive.show();
        }
      } else {
        this.toastr.error(res.message, 'Thông báo', {
          timeOut: 3000, positionClass: 'toast-bottom-right',
        })
        this.confirmCancelActive.hide();
      }
      setTimeout(() => {
        this.loadListStamp(this.batchActionIdDetail);
        this.fetch();
      }, 200)

    }, (error) => {
      this.toastr.error(error.message, 'Thông báo', {
        timeOut: 3000, positionClass: 'toast-bottom-right',
      })
    })
  }

  /** Tuanba: 22-9-2023 : Kích hoạt bảo hành**/

  infoActive: any = {};
  cusomerUpdate: any = {};
  listRequire: any = [];
  imagesFields: any = {};
  listField;
  list_districtActive: Array<IOption> = [];
  typeField = {};
  typeName = {};
  public errMsgAlertSingleStamp = '';
  modalRef: any;
  list_city: Array<IOption> = [];

  cities: any;

  // openActiveTemp(template: TemplateRef<any>) {
  //   console.log('thí.sadasd', this.transfer_id)
  //   this.productRoadmapService.getListSerialActiveGuarannte(this.transfer_id).subscribe((res) => {
  //     console.log('res', res)
  //     if (res.code == 1) {
  //       const result = res.data.map(item => `${item.prefix}-${item.number}`).join('\n');
  //       $('#serial_ids').val(`${result}`)
  //       console.log('result', result)
  //     }
  //
  //   })
  //   this.modalRef = this.modalService.show(template);
  //   this.choiceActive();
  // }
  getCity() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      const cities = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
        cities.push({value: c.id.toString(), label: c.name});

        // if (c.city_name == this.store.customer?.city) {
        //     this.loadDistrictData(c.id);
        // }
      });
      this.cities = citiesList;
      this.list_city = cities;
    });
  }

  openModalActiveGuarantee(template: TemplateRef<any>) {
    console.log('thisadasd', this.batchActionIdDetail)
    this.batchService.getListStamp(this.batchActionIdDetail).subscribe((res) => {
      console.log('res', res)
      if (res.code == 1) {
        const result = res.data.map(item => `${item.prefix}-${item.number}`).join('\n');
        $('#serial_ids').val(`${result}`)
        console.log('result', result)
      }

    })

    // Auto-fill Warranty Reminder config from Product
    if (this.batch_detail && this.batch_detail.product_id) {
      this.productService.getDetaiById(this.batch_detail.product_id).subscribe((res: any) => {
        if (res && res.error == false) {
          // MOCK for testing Product 8802131142428
          if ((res.data && res.data.sku === '8802131142428') || (this.batch_detail && this.batch_detail.product_id === '8802131142428')) {
            this.infoActive.is_maintenance_reminder = true;
            this.infoActive.maintenance_mode = 'once';
            this.infoActive.maintenance_cycle = 1;
            this.infoActive.maintenance_cycle_unit = 'months';

            this.infoActive.is_expired_reminder = true;
            this.infoActive.expired_mode = 'once';
            this.infoActive.expired_cycle = 1;
            this.infoActive.expired_cycle_unit = 'months';
          } else {
            this.infoActive.is_maintenance_reminder = res.data.is_maintenance_reminder || false;
            this.infoActive.maintenance_mode = res.data.maintenance_mode || 'once';
            this.infoActive.maintenance_cycle = res.data.maintenance_cycle || null;
            this.infoActive.maintenance_cycle_unit = res.data.maintenance_cycle_unit || 'months';

            this.infoActive.is_expired_reminder = res.data.is_expired_reminder || false;
            this.infoActive.expired_mode = res.data.expired_mode || 'once';
            this.infoActive.expired_cycle = res.data.expired_cycle || null;
            this.infoActive.expired_cycle_unit = res.data.expired_cycle_unit || 'months';
          }
        }
      });
    }

    this.modalRef = this.modalService.show(template);
    this.choiceActive()
  }

  getListDistrict(city_Id: any, districtID: any, status) {
    console.log(9999999)
    if (city_Id) {
      this.addressService
        .getDistrict({city_id: city_Id})
        .toPromise()
        .then((res: any) => {
          if (res.status == 200) {
            const districts = [];
            for (const d of res.data.districts) {
              districts.push({value: d.id.toString(), label: d.name});
            }
            this.list_districtActive = districts;
            console.log('list_districtActive', this.list_districtActive)
            console.log('districtID', districtID)

            this.infoActive.district = districtID ? districtID.toString() : null;

          }
        });
    }
  }

  deleteImageFields(id, fieldKey) {
    for (let i = 0; i < this.imagesFields[fieldKey].length; i++) {
      if (this.imagesFields[fieldKey][i].id === id) {
        this.imagesFields[fieldKey].splice(this.imagesFields[fieldKey].indexOf(this.imagesFields[fieldKey][i]), 1);
        break;
      }
    }
  }

  tusUploadFields = (item, fieldKey) => {
    const numberImages = item.target.files.length;
    if (numberImages > 5) {
      this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = res.data.url;
            if (this.imagesFields[fieldKey].length >= 5) {
              this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.imagesFields[fieldKey].push(image2);
            }
          }
        });
      }
    }
  };

  choiceActive() {
    // this.status = 1;
    console.log('ngan beo');
    this.cusomerUpdate = {}
    this.listRequire = []
    this.cusomerUpdate['nameField'] = {}
    this.cusomerUpdate['fields'] = {}
    this.stampService.getFieldGuaranteeCustomes().subscribe((res) => {
      if (res.data.length > 0) {
        this.listField = res.data;
        console.log('this.listField', this.listField)
        this.listField.map((val) => {
          this.typeField[val.key] = val.type
          this.typeName[val.key] = val.name
          if (val.require === 1 && val.status === 1) {
            this.listRequire.push(val.key)
          }
          this.cusomerUpdate['nameField'][val.key] = val.name


          if (val.type === 'checkbox') {
            this.cusomerUpdate['fields'][val.key] = {}
            val.value_f.map((n) => {
              this.cusomerUpdate['fields'][val.key][`check${n.id}`] = false
            })
          }
          if (val.type === 'image') {
            this.imagesFields[val.key] = []
            this.cusomerUpdate['fields'][val.key] = []
            console.log('this.imagesFields', this.imagesFields)
          }


          if (this.infoActive.fields && this.infoActive.fields.length > 0 && this.infoActive.fields !== null) {
            this.infoActive.fields.map((item) => {
              if (item.key === val.key) {
                if (val.type === 'date') {
                  this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                } else if (val.type === 'checkbox') {
                  this.cusomerUpdate['fields'][val.key] = {}
                  val.value_f.map((n) => {
                    if (item.string_values.split(',').includes(String(n.id))) {
                      this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                    }
                  })
                } else if (val.type === 'image') {
                  this.imagesFields[val.key] = item.string_values === null ? [] : item.string_values
                } else {
                  this.cusomerUpdate['fields'][val.key] = item.string_values
                }
              }

            })

          }
          console.log('this.cusomerUpdate', this.cusomerUpdate)
        })
      }

    });

  }

  findCustomerByPhone() {
    console.log(111);
    if (this.infoActive.phone) {
      if (this.infoActive.phone.length > 0) {
        this.stampService
          .getUserByPhone(this.infoActive.phone)
          .subscribe((res) => {
            if (!res.error) {
              if (res.data.customer) {
                // tslint:disable-next-line:prefer-const
                let info = res.data.customer;
                this.toastr.info(
                  `Đã tải về thông tin khách hàng có số điện thoại` +
                  this.infoActive.phone,
                  '',
                  {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  });
                this.infoActive.name = info.name;
                this.infoActive.email = info.email;
                this.infoActive.address = info.address;
                this.infoActive.fields = info.fields;


                this.cusomerUpdate = {}
                this.listRequire = []
                this.cusomerUpdate['nameField'] = {}
                this.cusomerUpdate['fields'] = {}
                this.stampService.getFieldGuaranteeCustomes().subscribe((res) => {
                  if (res.data.length > 0) {
                    this.listField = res.data;
                    this.listField.map((val) => {
                      this.typeField[val.key] = val.type
                      this.typeName[val.key] = val.name
                      if (val.require === 1 && val.status === 1) {
                        this.listRequire.push(val.key)
                      }
                      this.cusomerUpdate['nameField'][val.key] = val.name
                      if (val.type === 'checkbox') {
                        this.cusomerUpdate['fields'][val.key] = {}
                        val.value_f.map((n) => {
                          this.cusomerUpdate['fields'][val.key][`check${n.id}`] = false
                        })
                      }
                      if (this.infoActive.fields && this.infoActive.fields.length > 0) {
                        this.infoActive.fields.map((item) => {
                          if (item.key === val.key) {

                            if (val.type === 'date') {

                              this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                            } else if (val.type === 'checkbox') {
                              this.cusomerUpdate['fields'][val.key] = {}
                              val.value_f.map((n) => {
                                if (item.string_values.split(',').includes(String(n.id))) {
                                  this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                                }
                              })

                            } else if (val.type === 'image') {
                              this.imagesFields[val.key] = item.string_values === null ? [] : item.string_values
                            } else {
                              this.cusomerUpdate['fields'][val.key] = item.string_values

                            }
                          }

                        })
                      }
                    })
                  }

                });


                if (info.city && info.district) {
                  this.infoActive.city = info.city.toString();
                  this.getListDistrict(
                    this.infoActive.city,
                    info.district,
                    1
                  );
                }

              }
            }
          });
      }
    }
  }

  excecute() {

    this.errMsgAlertSingleStamp = '';
    const request: any = {
      customer: {},
    };
    request.status = 1;
    request.bundleType = 0;
    if (!this.infoActive.phone || this.infoActive.phone == '') {
      this.toastr.warning(`Số điện thoại không được để trống`, '', {
        timeOut: 400000000,
        positionClass: 'toast-bottom-right',
      });
      return;
    } else {
      request.customer.phone = this.infoActive.phone;
      $('#phoneValidate').text('');
    }

    if (!this.infoActive.name || this.infoActive.name == '') {
      this.toastr.warning(`Tên khách hàng không được để trống`, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    } else {
      request.customer.name = this.infoActive.name;
      $('#nameValidate').text('');
    }
    this.infoActive.serial_ids = $('#serial_ids').val();
    if (!this.infoActive.serial_ids || this.infoActive.serial_ids == '') {
      this.toastr.warning(`Serial không được để trống`, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    } else {
      const listContent = [];
      const content = this.infoActive.serial_ids.toUpperCase().split('\n');
      content.map((res) => {
        if (res.trim().length > 0) {
          if (!isNaN(res.trim().split('-')[res.trim().split('-').length - 1])) {
            listContent.push({
              prefix: res.trim().split('-')[0],
              serialStart: res.trim().split('-')[res.trim().split('-').length - 1],
              serialEnd: res.trim().split('-')[res.trim().split('-').length - 1]
            });
          } else {
            this.toastr.warning(
              `Định dạng serial không đúng`,
              `Kích hoạt thất bại`,
              {
                timeOut: 3000,
                positionClass: 'toast-bottom-right',
                enableHtml: true,
              }
            );
            return
          }

        }
      });
      request.stamps = listContent;
      $('#serialValidateInfoActive').text('');
    }
    if (this.infoActive.email && this.infoActive.email != '') {
      request.customer.email = this.infoActive.email;
    } else {
      request.customer.email = ''
    }
    if (this.infoActive.address && this.infoActive.address != '') {
      request.customer.address = this.infoActive.address;
    } else {
      request.customer.address = ''
    }
    // if (this.infoActive.country && this.infoActive.country != '') {
    //   request.customer.country = parseInt(this.infoActive.country);
    // }
    if (this.infoActive.city && this.infoActive.city != '') {
      request.customer.city = parseInt(this.infoActive.city);
    }
    if (this.infoActive.district && this.infoActive.district != '') {
      request.customer.district = parseInt(this.infoActive.district);
    }

    // if (this.variantId) {
    //   request.variant_id = this.variantId;
    // }

    if (this.infoActive.product_code) {
      request.product_code = this.infoActive.product_code;
    }
    console.log('request', request);

    for (const val in this.imagesFields) {
      console.log(`${val}: ${this.imagesFields[val]}`);
      this.cusomerUpdate['fields'][val] = this.imagesFields[val];
    }

    const fieldsData = {}
    for (const property in this.cusomerUpdate['fields']) {
      if (this.typeField[property] === 'select' && this.listRequire.includes(property) && this.cusomerUpdate['fields'][property] === '-1') {
        this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return;
      }
      if (this.typeField[property] === 'image') {
        fieldsData[property] = this.cusomerUpdate['fields'][property]
        if (this.listRequire.includes(property) && fieldsData[property].length === 0) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

      if (this.typeField[property] === 'checkbox') {
        const arr = []
        for (const val in this.cusomerUpdate['fields'][property]) {
          if (typeof this.cusomerUpdate['fields'][property][val] === 'boolean') {
            if (this.cusomerUpdate['fields'][property][val]) {
              const split = val.split('check')[1]
              arr.push(split)
            }
          } else {
            arr.push(this.cusomerUpdate['fields'][property][val])
          }

        }
        fieldsData[property] = arr.join(',')

        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;

        }
      } else if (this.typeField[property] === 'date') {
        console.log('this.cusomerUpdate.fields[property]', this.cusomerUpdate['fields'][property])
        if (this.cusomerUpdate['fields'][property]) {
          let dataDate = this.cusomerUpdate['fields'][property]
          if (typeof this.cusomerUpdate['fields'][property] === 'object') {
            dataDate = moment(this.cusomerUpdate['fields'][property]).format('DD/MM/YYYY')
          }
          const date = dataDate.split('/')
          const dateTime = new Date(`${date[1]} ${date[0]} ${date[2]}`)
          fieldsData[property] = new Date(dateTime.getTime() - (dateTime.getTimezoneOffset() * 60000)).toISOString();
        }
        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;

        }
      } else {

        fieldsData[property] = this.cusomerUpdate['fields'][property]

        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

    }
    request.customer.fields = fieldsData

    // Warranty Reminder fields
    request.is_maintenance_reminder = this.infoActive.is_maintenance_reminder;
    if (this.infoActive.is_maintenance_reminder) {
      request.maintenance_mode = this.infoActive.maintenance_mode;
      request.maintenance_cycle = this.infoActive.maintenance_cycle;
      request.maintenance_cycle_unit = this.infoActive.maintenance_cycle_unit;
    }

    request.is_expired_reminder = this.infoActive.is_expired_reminder;
    if (this.infoActive.is_expired_reminder) {
      request.expired_mode = this.infoActive.expired_mode;
      request.expired_cycle = this.infoActive.expired_cycle;
      request.expired_cycle_unit = this.infoActive.expired_cycle_unit;
    }

    if (
      request.customer.phone &&
      request.customer.phone !== '' &&
      request.customer.name &&
      request.customer.name !== ''
    ) {
      this.stampService
        .activeGuaranteeStamps(request)
        .toPromise()
        .then((res: any) => {
          if (res.code === 1) {

            this.toastr.success(
              `<div>Thành công: <b>${res.data.totalSuccess}</b>, Thất bại: <b>${res.data.totalFailure}</b></div>`,
              `Kích hoạt thành công`,
              {
                timeOut: 5000,
                positionClass: 'toast-bottom-right',
                enableHtml: true,
              }
            );
            // this.loadData({}, this.isSorting);
            this.modalRef.hide();
            this.infoActive = {};
          } else if (res.code === 1800) {

            this.errMsgAlertSingleStamp = res.message;
            $('.stampSingleAlert').css('opacity', '1');
            // this.loadData({}, this.isSorting);
            this.modalRef.hide();
            this.infoActive = {};
            setTimeout(() => {
              $('.stampSingleAlert').css('opacity', '0');
            }, 5000)
          } else {
            this.toastr.error(
              res.message || `Kích hoạt thất bại`,
              `Thất bại`,
              {
                timeOut: 5000,
                positionClass: 'toast-bottom-right',
                enableHtml: true,
              }
            );
            EvsErr.evs_err(res, false);
          }
        })
        .catch((err: any) => {
          this.errMsgAlertSingleStamp = err.message;
          $('.stampSingleAlert').css('opacity', '1');
          setTimeout(() => {
            $('.stampSingleAlert').css('opacity', '0');
          }, 5000)
        });
    }
  }

  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  public messageExport;

  exportDetailCode() {
    this.messageExport = '';
    $('.stampBoxStampAlertAdd').css('opacity', '0');
    const data_filter: any = {
      'batchActionId': this.batchActionIdDetail
    };
    const body = {
      exportTypeEnum: 'ALL_STAMP_IN_BATCH_ACTION',
      fields: data_filter
    };
    this.exportService.exportReport(body).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('HE_THONG_DANG_XU_LY');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        $('.stampBoxStampAlertAdd').css('opacity', '0');
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }

  /*** Tuanba:27-02-2024: Thay api xuất báo cáo **/
  downloadBatchWithPassword() {
    if (Object.keys(this.columns).length <= 0) {
      this.toastr.warning('Phải chọn ít nhất một cột', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
      return;
    } else {
      if (!this.password) {
        this.toastr.warning('Password không được để trống', 'Thông báo:', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        })
        return;
      } else {
        const body = {
          passwordDownload: this.password,
          typeStampExport: []
        }
        if (this.columns.serial) {
          body.typeStampExport.push('serial');
        }
        if (this.columns.qrm) {
          body.typeStampExport.push('qrm');
        }
        if (this.columns.qri) {
          body.typeStampExport.push('qri');
        }
        if (this.columns.sms) {
          body.typeStampExport.push('sms');
        }
        this.batchService
          .downloadBatchWithPassword(this.batchId1, body)
          .toPromise()
          .then((res: any) => {
            if (res.status == 200 && res.data) {
              this.bsModalDownload.hide();
              setTimeout(() => {
                this.confirmTemplateDownload.show();
              }, 500)
            } else {
              this.toastr.warning(res.message, 'Thông báo:', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
          })
          .catch((err: any) => {
            this.toastr.warning(err.message, 'Thông báo:', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          });
      }
    }
  }

  getPasswordEmailDownloadBatch() {
    console.log('batch ID', this.batchId1)
    this.batchService.getPasswordDownloadBatch(this.batchId1).toPromise().then((res) => {
      if (res.status == 200 && res.data) {
        console.log('res')
        this.user_email = res.data.receiverEmail
      }
    })
  }

  hideConfirmTemplateDownload() {
    this.confirmTemplateDownload.hide();
  }

  preventNonPositiveNumber(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    // Cho phép: phím số (0–9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return;
    }
    const target = event.target as HTMLInputElement;
    // Ngăn nhập số 0 ở đầu tiên
    if ((target.selectionStart === 0 && target.selectionEnd === target.value.length && charCode === 48) || 
        (target.value === '' && charCode === 48)) {
      event.preventDefault();
    }
  }

  onPastePositiveNumber(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    if (!/^[1-9][0-9]*$/.test(pastedText)) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/list/modalListBatchChild.component.ts